import { Typography, useUiBaseConfig } from '@faceup/ui-base'
import type { ReactNode } from 'react'

type ReportRowProps = {
  label: ReactNode
  children: ReactNode
  dataTest?: string
}

export const ReportRow = ({ label, children, dataTest }: ReportRowProps) => {
  const { token } = useUiBaseConfig()

  return (
    <div>
      <Typography.Text
        strong
        size='sm'
        style={{ color: token.colorTextSecondary, display: 'block' }}
      >
        {label}
      </Typography.Text>
      <Typography.Text
        className='sensitive'
        style={{ whiteSpace: 'pre-wrap' }}
        {...(dataTest && { 'data-test': dataTest })}
      >
        {children}
      </Typography.Text>
    </div>
  )
}
